import { useState, useEffect } from 'react';

// Custom hook to check for mobile screen
const useIsMobile = (limit = 700) => {
  // State to hold the check
  const [isMobile, setIsMobile] = useState(window.innerWidth < limit);

  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth < limit);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return isMobile;
};

export default useIsMobile;
